import React, { useCallback, useState } from "react";
import styles from "./styles.module.scss";
import CommonFilter from "../../../../atoms/CommonFilter";
import DateRangePickerShortCuts from "../../../../organisms/dateRangePicker";
import {
  addHours,
  startOfDay,

  subDays
} from "rsuite/esm/internals/utils/date";
import TimeReportChart from "./TimeReportChart";
import {
  getEmployeeList,
  getAllProjects,
  getTeamsList,
  getClientList,
} from "../../../../../services/basicGets";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { getData } from "../../../../../services";
import { useSelector } from "react-redux";
import TaskManagement from "../../taskManagement";

const GraphContainerClient = ({ clientDash, client , dates  }) => {
  const [cookies] = useCookies(["e_t"]);
  const defaultToday = new Date();
  const [projects, setProjects] = useState([]);
  const [teams, setTeams] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [Client, setClient] = useState([]);
  const [filters, setFilters] = useState({});
  // const [date, setDate] = useState({
  //   start_date: addHours(startOfDay(startOfMonth(defaultToday)), 12),
  //   end_date: addHours(startOfDay(endOfMonth(defaultToday)), 12),
  // });

  const [date, setDate] = useState({
    start_date: addHours(startOfDay(subDays(defaultToday, 14)), 12), // 14 days ago
    end_date: addHours(startOfDay(defaultToday), 12), // Today
  });

  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  useEffect(() => {
    const params = {
      business_id: cookies.buid,
      ...(!isAdmin && { employee_id: cookies.euid })
    };
    (async () => {
      const emp = await getEmployeeList({
        params,
        token: cookies.e_t,
      });
      // const teamRoles = await getTeamsList({
      //   token: cookies.e_t,
      // });
      // setTeams(teamRoles);
      const teamProjects = await getAllProjects({
        params,
        token: cookies.e_t,
      });

      const clients = await getClientList({
              token: cookies.e_t,
              params:{
                business_id:cookies.buid,
              }
            });

      const allTeams = await getTeamsList({
        params,
        token: cookies.e_t,
      });

      setClient(clients?.data);
      setProjects(teamProjects?.data);
      setEmployees(emp?.employeeResponseValueLabel);
      setTeams(allTeams?.data?.teams);
    })();
  }, []);

  const filterOptions = [
    // {
    //   id: "project",
    //   label: "Project",
    //   type: "multi-select",
    //   options: projects,
    // },
    {
      id: "client",
      label: "Clients",
      type: "single-select",
      options: Client || [],
    },
    // {
    //   id: "team",
    //   label: "Team",
    //   type: "multi-select",
    //   options: teams,
    // },

    // {
    //   id: "employee",
    //   label: "Employee",
    //   type: "multi-select",
    //   options: employees,
    // },
  ];


  const getDashboardGraphData = useCallback(async () => {
    try {
      const res = await getData({
        endpoint: "Dashboard/getTaskTimerDashboardGraph",
        params: {
          start_date: dates?.start_date,
          end_date: dates?.end_date,
          project_ids: JSON.stringify(filters?.project),
          employee_ids: JSON.stringify(filters?.employee),
          team_ids: JSON.stringify(filters?.team),
          client_ids: clientDash ? JSON.stringify(client) : JSON.stringify(filters?.client), // Use client prop if clientDash
          employee_id: isAdmin ? null : cookies.euid,
          business_id: cookies.buid,
        },
        token: cookies.e_t,
      });
      if (res) {
        setTableData(res);
      }
    } catch (error) {
      console.error(error); // Use console.error for errors
    }
  }, [cookies.e_t, filters, date , dates, client, clientDash]);

  useEffect(() => {
    getDashboardGraphData();
  }, [getDashboardGraphData]);




  return (
    <>
      <div className={styles.graph_container}>
        {!clientDash && <div className="d-flex justify-content-between">
          <CommonFilter
            filters={filterOptions}
            onFilterChange={handleFilterChange}
          />

          <DateRangePickerShortCuts setDate={setDate} />
        </div> }
        

        <TimeReportChart categorydata={tableData?.category} data={tableData?.chart_data?.[0]?.data} />

      </div>
    </>
  );
};

export default GraphContainerClient;
